<template>
  <div  :style="{height:height + 'px',width:width+'px'}" class="rollScreen_container" id ="rollScreen_container">
    <div class="rollScreen_list" :style = "{transform:height<totalHeight?transform:'none','transition-duration':chixuTime+'s'}" :class="{rollScreen_list_unanim:num===0}">

      <div class="rollScreen_once" v-for="(item,index) in contentArr" :key="index">
        <slot name="scroll" v-bind:todo="item"></slot>
      </div>
      <div v-if="height<totalHeight" class="rollScreen_once" v-for="(item,index) in contentArr" :key="index+contentArr.length">
        <slot name="scroll" v-bind:todo="item"></slot>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      width: {
        default: 475,
        type: null,
      },
      height: {
        default: 40,
        type: null,
        required: true
      }, // 每行元素的高度
      lineNum: {
        default: 2,
        type: Number
      }, // 显示行数
      contentArr: {
        default: null,
        type: Array
      }, // 简单文本轮播
      dLength: {
        default: null,
        type: Number
      }, // 自定义插槽内容的时候必须传自定义内容的长度
      time: {
        default: 15000,
        type: Number // 定义轮播切换速度
      },
      totalTime: {
        default:1,
        type: Number
      },
      startTime: {
        default: 0,
        type:Number
      },
      totalHeight: {
        default: 0,
        type: Number,
        required: true
      }
    },
    data: function () {
      return {
        num: 0,
        loopTime: this.time,
        chixuTime:0,
        scrollHeight:0
      }
    },
    computed: {
      transform: function () {
        return 'translateY(-' + this.scrollHeight + 'px)'
      },
      canScroll () {
        if (this.totalHeight>=this.Height) {
          return true
        }else{
          return false
        }
      }
    },
    beforeCreate: function () {
    },
    methods: {
      change () {
        var that = this
        if (that.num == 1){
          that.num = 0
          that.scrollHeight = 0
          setTimeout(() => {
            that.num = 1
            that.scrollHeight = that.totalHeight
          })
        }else {
          this.num =1
          setTimeout(() => {
            that.chixuTime = that.totalTime *2
            that.scrollHeight = that.totalHeight
          })
        }
      }
    },
    mounted: function () {
      // console.log('mounted')
      // console.log(this.totalTime)
      let that = this
      this.num =1
      setTimeout(() => {
        that.chixuTime = that.totalTime
        that.scrollHeight = that.totalHeight
        setInterval(function () {
          that.num = 0
          that.scrollHeight = 0
          setTimeout(function () {
            that.num = 1
            that.scrollHeight = that.totalHeight
          },50)
        }, that.totalTime*1000+50)
      })

      // setInterval(that.change,that.totalTime*1000)
      // setTimeout(function () {
        // if ((this.contentArr != null && this.contentArr.length < this.lineNum) || (this.dLength != null && this.dLength < this.lineNum)) {
        //   console.error('轮播显示行数不能超过数据总行数')
        // } else {
        //   // 先判断轮播切换速度，如果小于动画播放时间则提示切换速度过快
        //   if (_this.loopTime <= 1000) {
        //     console.warn('轮播切换速度过快，至少大于1s')
        //     _this.loopTime = 1000
        //   }
        //   // 两种轮播 第一种contentArr！= null 第二种自定义插槽
        //   if (_this.contentArr !== null) {
        //     setInterval(function () {
        //       if (_this.num !== _this.contentArr.length) {
        //         _this.num++
        //       } else {
        //         _this.num = 0
        //         setTimeout(function () {
        //           _this.num++
        //         }, 50)
        //       }
        //     }, _this.loopTime)
        //   } else if (_this.dLength !== null) {
        //     setInterval(function () {
        //       if (_this.num !== _this.dLength) {
        //         _this.num++
        //       } else {
        //         _this.num = 0
        //         setTimeout(function () {
        //           _this.num++
        //         }, 50)
        //       }
        //     }, _this.loopTime)
        //   } else if (_this.dLength === null && _this.dLength === null) {
        //     console.error('contentArr 和 dLength 均为空，rollScreen组件运行出错')
        //   }
        // }


      // },1)
    },
    // mounted: function () {
    //   // 复制一份slot的节点，如果直接用同名slot会报错
    //   if (this.dLength !== null) {
    //     for (let i = 0; i < this.dLength; i++) {
    //       this.$el.childNodes[0].appendChild(this.$slots.slide[i].elm.cloneNode(true))
    //     }
    //   }
    // }
  }
</script>

<style>
    .rollScreen_container{
        display: inline-block;
        position:relative;
        overflow: hidden;
    }
    .rollScreen_list{
        transition-timing-function: linear;
        padding:0;
        margin:0;
        list-style: none;
    }
    .rollScreen_list_unanim{
        transition: none
    }
    .rollScreen_once{
        list-style: none;
        width:100%;
    }
</style>
